import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50/80" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-xl text-background-50"></i>
              </div>
              <span className="text-xl font-bold text-background-50" style={{ fontFamily: 'var(--font-heading)' }}>
                吃瓜网
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              最新热门八卦娱乐资讯平台，海量吃瓜内容实时更新，独家爆料不断，让您第一时间掌握最劲爆的娱乐资讯。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500 transition-colors duration-200 text-background-50/60 hover:text-background-50 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500 transition-colors duration-200 text-background-50/60 hover:text-background-50 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-primary-500 transition-colors duration-200 text-background-50/60 hover:text-background-50 cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">热门分类</h3>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">快速链接</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/60 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-50/60 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-50/60 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-50/60 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  免责声明
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">联系我们</h3>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-background-50/60">
                <i className="ri-mail-line mt-0.5 text-primary-500"></i>
                <span>contact@chigua.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-50/60">
                <i className="ri-phone-line mt-0.5 text-primary-500"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-50/60">
                <i className="ri-map-pin-line mt-0.5 text-primary-500"></i>
                <span>北京市朝阳区星光大道88号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/50">
            &copy; {currentYear} 吃瓜网 - 版权所有 | 京ICP备2024XXXXXXXX号
          </p>
          <p className="text-sm text-background-50/50">
            以吃瓜之名，探娱乐圈真相
          </p>
        </div>
      </div>
    </footer>
  );
}